module.exports = __webpack_public_path__ + "static/media/flip-card.5de435ff.mp3";